// ============================================================================
// UKRAINIAN TRANSLATIONS - CHAPTER 6: МІСІЇ ПАВЛА
// ============================================================================
// Рівні 66-78 (13 рівнів, 39 питань)

export const chapter6Translations = {
  name: "Місії Павла",
  description: "До країв землі...",
  
  spiritualWisdom: {
    principle: "Євангеліє для всіх народів і має бути проголошене всьому світу",
    scripture: "Ідіть і навчіть усі народи (Матвія 28:19)",
    application: "Кожен християнин покликаний бути свідком Христа там, де Бог його поставив"
  },
  
  levels: {
    66: {
      name: "Перша Місіонерська Подорож",
      challenge: "Відокремте Мені Варнаву і Савла на діло, до якого Я покликав їх...",
      easy: {
        question: "Хто супроводжував Павла в його першій подорожі?",
        options: ["Петро", "Варнава", "Сила", "Тимофій"],
        hint: "'Син утіхи'",
        funFact: "👥 Варнава прийняв Павла після його навернення - провидінне партнерство!"
      },
      medium: {
        question: "З якого міста вони вирушили в місію?",
        options: [
          "Єрусалим",
          "Антіохія Сирійська",
          "Тарс",
          "Дамаск"
        ],
        hint: "Перша змішана церква з юдеїв та язичників",
        funFact: "🚢 Антіохія: порт відправлення євангелізації західного світу!"
      },
      hard: {
        question: "Що відкриває ця перша подорож про місіонерську стратегію?",
        options: [
          "Треба залишатися у своєму регіоні",
          "Євангеліє долає всі культурні кордони",
          "Лише юдеї можуть бути спасені",
          "Місія факультативна"
        ],
        hint: "Мова йде про універсальність послання",
        funFact: "🌊 Перетнути Середземне море = зробити крок до світової євангелізації!"
      }
    },
    
    67: {
      name: "На Кіпрі з Елімою",
      challenge: "О, сповнений всякої хитрості і всякого лукавства, сину диявола...",
      easy: {
        question: "Який чарівник протистав Павлу на Кіпрі?",
        options: ["Симон", "Еліма", "Аполлос", "Олександр"],
        hint: "Лжепророк, який хотів відвернути проконсула",
        funFact: "🪄 Перше пряме протистояння між Євангелієм і магією!"
      },
      medium: {
        question: "Що зробив Павло з Елімою для покарання?",
        options: [
          "Вигнав його",
          "Осліпив його тимчасово",
          "Проігнорував його",
          "Сперечався з ним"
        ],
        hint: "Тимчасова сліпота, щоб відкрити йому духовні очі",
        funFact: "👁️ Божественна іронія: той, хто осліплював душі, стає тимчасово сліпим!"
      },
      hard: {
        question: "Як цей епізод ілюструє силу Євангелія?",
        options: [
          "Насильство необхідне",
          "Божественна істина тріумфує над брехнею",
          "Треба боротися з усіма чарівниками",
          "Павло був мстивим"
        ],
        hint: "Мова йде про божественний авторитет перед обманом",
        funFact: "⚡ Проконсул вірить, бачачи божественну силу - ефективна демонстрація!"
      }
    },

    68: {
      name: "В Антіохії Пісідійській",
      challenge: "Вам передусім належало проповідувати слово Боже...",
      easy: {
        question: "Де проповідував Павло, прибуваючи в місто?",
        options: [
          "На громадській площі",
          "Спочатку в синагозі",
          "У багатих",
          "В язичницьких храмах"
        ],
        hint: "Він завжди починав зі свого народу",
        funFact: "🕍 Місіонерська стратегія: спочатку до юдеїв, потім до язичників!"
      },
      medium: {
        question: "Як юдеї відреагували на послання Павла?",
        options: [
          "Всі прийняли його",
          "Розділилися: одні увірували, інші протистали",
          "Залишилися байдужими",
          "Негайно вигнали його"
        ],
        hint: "Класичний поділ перед Євангелієм",
        funFact: "⚖️ Євангеліє завжди ділить: прийняття або відкидання, не байдужість!"
      },
      hard: {
        question: "Чому Павло звертається до язичників?",
        options: [
          "Він віддавав перевагу язичникам",
          "Відкидання юдеїв відкриває двері народам",
          "Це було легше",
          "Він залишав свою місію"
        ],
        hint: "Мова йде про пророче виконання",
        funFact: "🚪 'Світло для язичників' - пророцтво Ісаї, виконане Павлом!"
      }
    },

    69: {
      name: "Зцілення в Лістрі",
      challenge: "Боги в людській подобі зійшли до нас!",
      easy: {
        question: "Кого зцілив Павло в Лістрі?",
        options: [
          "Сліпого",
          "Кульгавого від народження",
          "Глухонімого",
          "Прокаженого"
        ],
        hint: "Хтось, хто ніколи не ходив",
        funFact: "🦵 Вражаюче чудо: 'Стань прямо на ноги твої!' - зцілююча віра!"
      },
      medium: {
        question: "За кого натовп прийняв Павла і Варнаву?",
        options: [
          "Царів",
          "Богів (Юпітера і Меркурія)",
          "Чарівників",
          "Пророків"
        ],
        hint: "Божества грецького пантеону",
        funFact: "⚡ Варнава = Юпітер (вражаючий), Павло = Меркурій (оратор) - культурне непорозуміння!"
      },
      hard: {
        question: "Як відреагував Павло на це ідолопоклонницьке поклоніння?",
        options: [
          "Приймає почесті",
          "Роздирає одяг і проповідує істинного Бога",
          "Мовчить з ввічливості",
          "Використовує ситуацію"
        ],
        hint: "Повне відкидання ідолопоклонства",
        funFact: "👔 Роздирання одягу = юдейський жах перед ідолопоклонством - повна чесність!"
      }
    },

    70: {
      name: "Побиття Камінням та Воскресіння",
      challenge: "Коли учні зібралися навколо нього, він встав і пішов у місто...",
      easy: {
        question: "Що зробили мешканці Лістри з Павлом?",
        options: [
          "Ув'язнили",
          "Побили камінням",
          "Вигнали",
          "Розп'яли"
        ],
        hint: "Традиційне юдейське покарання",
        funFact: "🪨 Від 'бога' до 'мертвого' за один день - непостійність людського натовпу!"
      },
      medium: {
        question: "Що зробив Павло після побиття камінням?",
        options: [
          "Втік з міста",
          "Сховався",
          "Встав і повернувся в місто",
          "Пішов до лікарні"
        ],
        hint: "Надприродна сміливість після передбачуваної смерті",
        funFact: "💪 Чудесне воскресіння або божественне зцілення - неймовірна сміливість!"
      },
      hard: {
        question: "Що розкриває це гоніння про ціну свідчення?",
        options: [
          "Треба уникати конфліктів",
          "Свідчити за Христа може коштувати життя",
          "Павло був необережним",
          "Гоніння марне"
        ],
        hint: "Мова йде про ціну справжнього свідчення",
        funFact: "✝️ 'Багатьма скорботами належить нам увійти' - реалізм Павла!"
      }
    },

    71: {
      name: "Єрусалимський Собор",
      challenge: "Якщо не обрізаєтеся, не можете спастися...",
      easy: {
        question: "Які важливі дебати відбулися на Єрусалимському соборі?",
        options: [
          "Хрещення",
          "Обрізання навернених язичників",
          "День суботній",
          "Приношення"
        ],
        hint: "Чи треба було стати юдеєм, щоб бути християнином?",
        funFact: "✂️ Перша серйозна криза: християнство чи юдео-християнство?"
      },
      medium: {
        question: "Яким було остаточне рішення собору?",
        options: [
          "Обов'язкове обрізання",
          "Свобода для язичників з деякими рекомендаціями",
          "Повне відокремлення від юдеїв",
          "Відстрочка рішення"
        ],
        hint: "Відкритість для язичників без серйозних обмежень",
        funFact: "🆓 Історична революція: Євангеліє вільне від закону Мойсея!"
      },
      hard: {
        question: "Яке значення має цей собор для вселенської Церкви?",
        options: [
          "Незначна подія",
          "Встановлює універсальність спасіння лише вірою",
          "Ділить Церкву",
          "Посилює законництво"
        ],
        hint: "Мова йде про основу вселенської Церкви",
        funFact: "🌍 Без цього рішення християнство залишилося б юдейською сектою!"
      }
    },

    72: {
      name: "Друга Подорож: Тимофій",
      challenge: "Павло хотів узяти його з собою і обрізав його заради юдеїв...",
      easy: {
        question: "Хто приєднався до Павла як молодий співробітник?",
        options: ["Марко", "Лука", "Тимофій", "Тит"],
        hint: "'Улюблений син' Павла",
        funFact: "👦 Тимофій: молодий вундеркінд, що став правою рукою Павла - успішне наставництво!"
      },
      medium: {
        question: "Чому Павло обрізав Тимофія, незважаючи на здобуту свободу?",
        options: [
          "Через юридичний обов'язок",
          "Через місіонерську стратегію серед юдеїв",
          "Через традицію",
          "Через помилку"
        ],
        hint: "Практична мудрість, щоб уникнути перешкод",
        funFact: "🎯 Свобода з мудрістю: 'Для всіх я став усім, щоб спасти хоча б деяких'!"
      },
      hard: {
        question: "Як ця позиція ілюструє місіонерську гнучкість?",
        options: [
          "Павло був непостійним",
          "Він адаптував свій метод, не компрометуючи Євангеліє",
          "Він поступався тиску",
          "Він був лицеміром"
        ],
        hint: "Мова йде про контекстуальну мудрість",
        funFact: "⚖️ Тверді принципи, гнучкі методи - мистецтво ефективного свідчення!"
      }
    },

    73: {
      name: "Видіння Македонця",
      challenge: "Прийди в Македонію і допоможи нам!",
      easy: {
        question: "Що побачив Павло в нічному видінні?",
        options: [
          "Ангела",
          "Македонця, що закликав його",
          "Ісуса, що говорив з ним",
          "Велике світло"
        ],
        hint: "Заклик про допомогу з Європи",
        funFact: "🌉 Вирішальне видіння: Євангеліє перетинає в Європу - історичний поворот!"
      },
      medium: {
        question: "Яке було перше євангелізоване європейське місто?",
        options: [
          "Афіни",
          "Коринф",
          "Филипи",
          "Солунь"
        ],
        hint: "Римська колонія в Македонії",
        funFact: "🏛️ Филипи: перша європейська церква - континент назавжди перетворений!"
      },
      hard: {
        question: "Що символізує це видіння для історії християнства?",
        options: [
          "Звичайний сон",
          "Провидінна експансія на Захід",
          "Галюцинація",
          "Зміна плану"
        ],
        hint: "Мова йде про Провидіння, що направляє історію",
        funFact: "🗺️ Без цього видіння Європа могла залишитися язичницькою - божественний план!"
      }
    },

    74: {
      name: "Лідія, Перша Європейська Навернена",
      challenge: "Господь відкрив серце Лідії, щоб вона слухала...",
      easy: {
        question: "Яким було ремесло Лідії?",
        options: [
          "Пекар",
          "Торговка багряницею",
          "Ткаля",
          "Гончар"
        ],
        hint: "Розкішна торгівля тієї епохи",
        funFact: "🟣 Пурпур = королівський колір, дуже дорогий - Лідія була заможною!"
      },
      medium: {
        question: "Де Павло зустрів Лідію?",
        options: [
          "На ринку",
          "Біля річки під час молитви",
          "У її домі",
          "У синагозі"
        ],
        hint: "Місце молитви просто неба",
        funFact: "🏞️ У Филипах не було синагоги - молитва біля води за традицією!"
      },
      hard: {
        question: "Що розкриває навернення Лідії про божественну роботу?",
        options: [
          "Вона була схильна",
          "Бог відкриває серця, готові прийняти Його Слово",
          "Це був збіг",
          "Павло був переконливим"
        ],
        hint: "Мова йде про божественну дію в наверненні",
        funFact: "💝 'Господь відкрив її серце' - Бог готує і відкриває душі!"
      }
    },

    75: {
      name: "В'язниця у Филипах",
      challenge: "Опівночі Павло і Сила молилися і співали хвалу Богу...",
      easy: {
        question: "Чому Павло і Сила були ув'язнені?",
        options: [
          "Крадіжка",
          "Порушення громадського порядку вигнанням беса",
          "Богохульство",
          "Повстання"
        ],
        hint: "Зцілення рабині-віщунки",
        funFact: "💸 Визволити душу коштує дорого її експлуататорам - економічне гоніння!"
      },
      medium: {
        question: "Що робили Павло і Сила у в'язниці?",
        options: [
          "Скаржилися",
          "Молилися і співали",
          "Готували свій захист",
          "Спали"
        ],
        hint: "Хвала незважаючи на кайдани",
        funFact: "🎵 Пісні хвали опівночі у в'язниці - непохитна віра, що вражає!"
      },
      hard: {
        question: "Як їхня позиція перетворила ситуацію?",
        options: [
          "Не мала ефекту",
          "Навернула тюремника після землетрусу",
          "Роздратувала вартових",
          "Звела їх з розуму"
        ],
        hint: "Потужне свідчення прикладом",
        funFact: "🌍 Землетрус + свідчення = навернення тюремника та його сім'ї!"
      }
    },

    76: {
      name: "В Афінах: Ареопаг",
      challenge: "Що ви, не знаючи, шануєте, те я проповідую вам...",
      easy: {
        question: "На який жертовник послався Павло в Афінах?",
        options: [
          "На бога Зевса",
          "На невідомого бога",
          "На Аполлона",
          "На Афіну"
        ],
        hint: "Таємничий напис, що послужив відправною точкою",
        funFact: "🏛️ 'Невідомому богу' - геніальна точка дотику з грецькою філософією!"
      },
      medium: {
        question: "Перед ким проповідував Павло в Афінах?",
        options: [
          "Звичайним натовпом",
          "Філософами епікурейцями і стоїками в Ареопазі",
          "Жерцями храмів",
          "Римським імператором"
        ],
        hint: "Грецька інтелектуальна еліта",
        funFact: "🧠 Ареопаг = стародавній Гарвард - Павло перед найбільшими мислителями!"
      },
      hard: {
        question: "Якою була реакція афінян на воскресіння?",
        options: [
          "Одностайне прийняття",
          "Поділ: глузування одних, інтерес інших",
          "Загальний гнів",
          "Повна байдужість"
        ],
        hint: "Типова реакція інтелектуалів на цю таємницю",
        funFact: "🤔 Воскресіння = камінь спотикання для гордого людського розуму!"
      }
    },

    77: {
      name: "Коринф: Павло Шатроткач",
      challenge: "Жив у них і працював, бо за ремеслом були шатроткачі...",
      easy: {
        question: "Яке ремесло практикував Павло, щоб заробляти на життя?",
        options: [
          "Рибалка",
          "Шатроткач",
          "Книжник",
          "Купець"
        ],
        hint: "Ручне ремесло, якому він навчився",
        funFact: "⛺ Павло: апостол-ремісник - гідність ручної праці у християн!"
      },
      medium: {
        question: "У кого зупинився Павло в Коринфі?",
        options: [
          "У готелі",
          "У Акили і Прискілли",
          "У правителя",
          "У синагозі"
        ],
        hint: "Пара шатроткачів, як і він",
        funFact: "👫 Акила і Прискілла: зразкова місіонерська пара - християнська гостинність!"
      },
      hard: {
        question: "Чому Павло працював своїми руками?",
        options: [
          "Лише через фінансову необхідність",
          "Щоб не бути тягарем і підтвердити своє свідчення",
          "Через сімейну традицію",
          "Тому що любив це ремесло"
        ],
        hint: "Мова йде про незалежність і достовірність",
        funFact: "💼 Фінансова автономія = свобода слова - Павло ні від кого не залежав!"
      }
    },

    78: {
      name: "Заколот в Ефесі",
      challenge: "Велика Артеміда Ефеська!",
      easy: {
        question: "Хто спровокував заколот проти Павла в Ефесі?",
        options: [
          "Римська влада",
          "Димитрій срібляр і ремісники",
          "Філософи",
          "Юдейські священики"
        ],
        hint: "Ті, хто виготовляли храми Артеміди",
        funFact: "🏛️ Перший страйк в історії: Євангеліє загрожує ідолопоклонницькій економіці!"
      },
      medium: {
        question: "Скільки часу Павло вчив в Ефесі?",
        options: [
          "6 місяців",
          "1 рік",
          "2 роки",
          "3 роки"
        ],
        hint: "Його найдовше місіонерське перебування",
        funFact: "📅 3 роки інтенсивного навчання - Ефес став важливим місіонерським центром!"
      },
      hard: {
        question: "Що розкриває цей заколот про соціальний вплив Євангелія?",
        options: [
          "Євангеліє нічого не змінює",
          "Воно перетворює економічні та соціальні структури",
          "Стосується лише релігії",
          "Уникає конфліктів"
        ],
        hint: "Мова йде про глибоку соціальну трансформацію",
        funFact: "💰 Коли Євангеліє просувається, ідоли втрачають свій ринок - економічний ефект!"
      }
    }
  }
};

export default chapter6Translations;
